import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import estadosBrasil from '../data/estadosBrasil';
import { TIPOS_CONSTRUCAO, PADROES_CONSTRUCAO, TIPO_PARA_CUB } from '../data/etapasObra';
// eslint-disable-next-line no-unused-vars
import { CUB_EXTRAS } from '../data/cubData';
import PlantaOverlay from '../components/PlantaOverlay';
// PlantaCleanEditor now lives in its own page: /qco-plan



// Opções de acabamento por ambiente
const OPCOES_PISO = ['Porcelanato', 'Porcelanato Premium', 'Porcelanato Simples', 'Cerâmica', 'Cerâmica antiderrapante', 'Concreto polido', 'Cimentado', 'Piso vinílico', 'Piso laminado', 'Madeira'];
const OPCOES_FORRO = ['Gesso', 'Gesso simples', 'Gesso sancado', 'PVC', 'Madeira', 'Laje aparente', 'Sem forro'];
const OPCOES_PE_DIREITO = ['2,80m', '3,00m', '3,10m', '3,20m'];
const OPCOES_ALTURA_REV = ['Até 1,50m', 'Até 2,10m', 'Piso ao teto'];
const OPCOES_RODAPE = ['Sem rodapé', 'Porcelanato', 'Cerâmica', 'PVC', 'Madeira'];
const OPCOES_REV_PAREDE = ['Pintura acrílica', 'Pintura látex', 'Tinta PVA', 'Tinta Acrílica', 'Cerâmica', 'Cerâmica meia-parede', 'Porcelanato', 'Textura', 'Papel de parede', 'Pedra natural', 'Sem revestimento'];
const REV_PRECISA_ALTURA = ['Cerâmica', 'Porcelanato', 'Pedra natural'];
const OPCOES_REBOCO = ['Massa corrida PVA', 'Massa corrida acrílica', 'Gesso liso', 'Massa fina (cimento)'];
const OPCOES_MAT_ESQUADRIA = ['Madeira', 'Alumínio', 'PVC', 'Vidro temperado', 'Ferro'];
const OPCOES_BANCADA = ['Granito', 'Mármore', 'Porcelanato', 'Inox', 'MDF', 'Corian'];
const OPCOES_PIA = ['Louça', 'Inox', 'Mármore', 'Granito', 'Corian', 'Tanque (louça)', 'Tanque (concreto)', 'Tanque (inox)'];
const OPCOES_SOLEIRA = ['Granito', 'Mármore', 'Porcelanato', 'Pedra natural', 'Sem soleira'];

// Auto-inclinação sugerida por tipo de telha
const INCLINACAO_POR_TELHA = {
  'Cerâmica colonial': '30',
  'Cerâmica romana': '30',
  'Cerâmica portuguesa': '30',
  'Concreto': '30',
  'Fibrocimento': '15',
  'Metálica/galvanizada': '15',
  'Sanduíche termoacústica': '15',
  'Laje impermeabilizada': '0',
};

export default function OrcamentoConfirmar() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tipoFluxo = searchParams.get('tipo') || 'cub';
  const isCub = tipoFluxo === 'cub';

  const [analise, setAnalise] = useState(null);
  const [nomeProjeto, setNomeProjeto] = useState('');
  const [areaTotal, setAreaTotal] = useState(0);
  const [tipoConstrucao, setTipoConstrucao] = useState('');
  const [padrao, setPadrao] = useState('');
  const [estado, setEstado] = useState('');
  const [comodos, setComodos] = useState([]);
  const [itensEspeciais, setItensEspeciais] = useState([]);
  const [itensDetectados, setItensDetectados] = useState([]);
  const [observacoes, setObservacoes] = useState([]);
  const [alertasBruno, setAlertasBruno] = useState([]);
  const [itensExternos, setItensExternos] = useState([]);
  const [externasAberta, setExternasAberta] = useState(true);
  const [areaGaragem, setAreaGaragem] = useState('');
  const [areaVaranda, setAreaVaranda] = useState('');
  const [areaSubsolo, setAreaSubsolo] = useState('');
  const [baixaConfianca, setBaixaConfianca] = useState(false);
  const [percentualDivergencia, setPercentualDivergencia] = useState(null);
  const [peDireito, setPeDireito] = useState('2,80m');
  const [peDireitoCustom, setPeDireitoCustom] = useState('');
  const [quantitativos_globais, setQuantitativosGlobais] = useState(null);
  const [acordeonAberto, setAcordeonAberto] = useState(null); // índice do cômodo expandido
  const [viewMode, setViewMode] = useState('planta');
  const [modoVisualizacao, setModoVisualizacao] = useState('familia');
  const [engineData, setEngineData] = useState(null);
  const [cobertura, setCobertura] = useState({
    tipo: '',
    areaM2: '',
    estrutura: 'madeira',
    inclinacao: '30',
  });




  useEffect(() => {
    try {
      const stored = localStorage.getItem('orcai_analise_planta');
      if (!stored) { navigate('/orcamento/novo'); return; }
      const data = JSON.parse(stored);
      setAnalise(data);
      setEngineData(data);
      if (!data.overlay_disponivel) setViewMode('tabela');
      setAreaTotal(data.area_total || 0);
      const isBlank = (v) => !v || v === '—' || v === '–' || v === '-' || v.trim() === '';
      setComodos((data.comodos || []).map(c => {
        // Pré-preencher acabamentos a partir do acabamento_padrao do motor (se não tiver definido)
        const ap = c.acabamento_padrao || {};
        const acab = c.acabamento || {};
        return {
          ...c,
          acabamento: {
            tipoPiso: isBlank(acab.tipoPiso) ? (ap.piso || '') : acab.tipoPiso,
            forro: isBlank(acab.forro) ? (ap.forro || '') : acab.forro,
            tipoRevParede: isBlank(acab.tipoRevParede) ? (ap.revParede || '') : acab.tipoRevParede,
            alturaRevestimento: isBlank(acab.alturaRevestimento) ? (ap.alturaRev || '') : acab.alturaRevestimento,
            tipoRodape: isBlank(acab.tipoRodape) ? '' : acab.tipoRodape,
            tipoReboco: isBlank(acab.tipoReboco) ? '' : acab.tipoReboco,
          },
        };
      }));
      setItensEspeciais(data.itens_especiais || []);
      setItensDetectados(data.itens_detectados || []);
      setObservacoes(data.observacoes || []);
      setAlertasBruno(data.alertas_bruno || []);
      setItensExternos(data.itens_externos || []);

      // Pre-fill from config
      const cfg = data.config || {};
      setTipoConstrucao(cfg.tipoConstrucao || '');
      setPadrao(cfg.padrao || '');
      setEstado(cfg.estado || '');
      setNomeProjeto(cfg.nomeProjeto || '');

      // Quantitativos globais e pé direito
      if (data.quantitativos_globais) {
        setQuantitativosGlobais(data.quantitativos_globais);
      }
      // Pé-direito: priorizar dados_gerais.pe_direito_padrao (vem do corte) > quantitativos_globais > default
      const pdValue = data.dados_gerais?.pe_direito_padrao
        || data.quantitativos_globais?.pe_direito_m
        || null;
      if (pdValue) {
        const pd = parseFloat(pdValue);
        if (pd > 0) {
          if (pd <= 2.65) setPeDireito('2,60m');
          else if (pd <= 2.85) setPeDireito('2,80m');
          else if (pd <= 3.05) setPeDireito('3,00m');
          else if (pd <= 3.15) setPeDireito('3,10m');
          else setPeDireito('3,20m');
        }
      }

            // Confidence data from 3-step analysis
      setBaixaConfianca(data.baixa_confianca || false);
      setPercentualDivergencia(data.percentual_divergencia ?? null);

      // Cobertura: prefill from dados_complementares (Passe 1C)
      const dc = data.dados_complementares || {};
      if (dc.tipo_cobertura || data.dados_gerais?.area_construida_indicada) {
        const tipoDetectado = (dc.tipo_cobertura || '').toLowerCase();
        let tipoCobertura = '';
        if (tipoDetectado.includes('colonial')) tipoCobertura = 'Cerâmica colonial';
        else if (tipoDetectado.includes('roman')) tipoCobertura = 'Cerâmica romana';
        else if (tipoDetectado.includes('portug')) tipoCobertura = 'Cerâmica portuguesa';
        else if (tipoDetectado.includes('concreto')) tipoCobertura = 'Concreto';
        else if (tipoDetectado.includes('metal') || tipoDetectado.includes('galvan') || tipoDetectado.includes('zinco')) tipoCobertura = 'Metálica/galvanizada';
        else if (tipoDetectado.includes('fibro')) tipoCobertura = 'Fibrocimento';
        else if (tipoDetectado.includes('sanduiche') || tipoDetectado.includes('termo')) tipoCobertura = 'Sanduíche termoacústica';
        else if (tipoDetectado.includes('laje')) tipoCobertura = 'Laje impermeabilizada';
        else if (tipoDetectado.includes('ceram') || tipoDetectado.includes('cerâm')) tipoCobertura = 'Cerâmica colonial';

        // Área da cobertura: usar area construída + ~10% (projeção telhado > area piso)
        const areaCoberturaEst = data.dados_gerais?.area_construida_indicada
          ? Math.round(parseFloat(data.dados_gerais.area_construida_indicada) * 1.1 * 100) / 100
          : '';

        setCobertura(prev => ({
          ...prev,
          tipo: tipoCobertura || prev.tipo,
          areaM2: areaCoberturaEst ? String(areaCoberturaEst) : prev.areaM2,
        }));
      }

      // Extract area from specific rooms — usa classificacao do JSON (Opus) ou fallback por nome
      const todosComodos = (data.comodos || []).map(c => {
        const ap = c.acabamento_padrao || {};
        const acab = c.acabamento || {};
        return {
          ...c,
          acabamento: {
            tipoPiso: isBlank(acab.tipoPiso) ? (ap.piso || '') : acab.tipoPiso,
            forro: isBlank(acab.forro) ? (ap.forro || '') : acab.forro,
            tipoRevParede: isBlank(acab.tipoRevParede) ? (ap.revParede || '') : acab.tipoRevParede,
            alturaRevestimento: isBlank(acab.alturaRevestimento) ? (ap.alturaRev || '') : acab.alturaRevestimento,
            tipoRodape: isBlank(acab.tipoRodape) ? '' : acab.tipoRodape,
            tipoReboco: isBlank(acab.tipoReboco) ? '' : acab.tipoReboco,
          },
        };
      });

      // Garagem: classificacao === 'garagem' OU nome contém 'garag'
      const codoGaragem = todosComodos.filter(c =>
        c.classificacao === 'garagem' || /garag/i.test(c.nome)
      );
      const totalGaragem = codoGaragem.reduce((s, c) => s + (parseFloat(c.area) || 0) * (parseInt(c.quantidade) || 1), 0);
      if (totalGaragem > 0) setAreaGaragem(String(Math.round(totalGaragem * 100) / 100));

      // Varanda: classificacao === 'varanda' OU nome contém varand/sacad/terra/gourmet/alpendre
      const codoVaranda = todosComodos.filter(c =>
        c.classificacao === 'varanda' || /varand|sacad|terra|gourmet|alpendre/i.test(c.nome)
      );
      const totalVaranda = codoVaranda.reduce((s, c) => s + (parseFloat(c.area) || 0) * (parseInt(c.quantidade) || 1), 0);
      if (totalVaranda > 0) setAreaVaranda(String(Math.round(totalVaranda * 100) / 100));

      // Subsolo: por nome
      const subsolo = todosComodos.find(c => /subsol/i.test(c.nome));
      if (subsolo) setAreaSubsolo(String(subsolo.area || ''));

      // Remover garagem/varanda da lista de comodos (evita dupla contagem)
      const nomesBloqueados = new Set([
        ...codoGaragem.map(c => c.nome),
        ...codoVaranda.map(c => c.nome),
      ]);
      const comodosFiltrados = todosComodos.filter(c => !nomesBloqueados.has(c.nome));
      setComodos(comodosFiltrados);

      // Recalcular area total automaticamente com coeficientes corretos
      const principalAuto = comodosFiltrados.reduce((s, c) => s + (parseFloat(c.area) || 0) * (parseInt(c.quantidade) || 1), 0);
      const totalAuto = principalAuto + (totalGaragem * 0.50) + (totalVaranda * 0.75);
      setAreaTotal(Math.round(totalAuto * 100) / 100);
    } catch {
      navigate('/orcamento/novo');
    }
  }, [navigate]);

  const recalcArea = () => {
    // Soma cômodos principais (coef 1.0)
    const principal = comodos.reduce((sum, c) => sum + (parseFloat(c.area) || 0) * (parseInt(c.quantidade) || 1), 0);
    // Aplica coeficientes de garagem (0.50) e varanda (0.75)
    const garagem = parseFloat(areaGaragem) || 0;
    const varanda = parseFloat(areaVaranda) || 0;
    const subsolo = parseFloat(areaSubsolo) || 0;
    const total = principal + (garagem * 0.50) + (varanda * 0.75) + (subsolo * 1.0);
    setAreaTotal(Math.round(total * 100) / 100);
  };

  const updateComodo = (idx, field, value) => {
    setComodos(prev => prev.map((c, i) => i === idx ? { ...c, [field]: value } : c));
  };

  const updateAcabamento = (idx, field, value) => {
    setComodos(prev => prev.map((c, i) => i === idx ? {
      ...c,
      acabamento: { ...(c.acabamento || {}), [field]: value }
    } : c));
  };

    const removeComodo = (idx) => {
    setComodos(prev => prev.filter((_, i) => i !== idx));
  };

  const addComodo = () => {
    setComodos(prev => [...prev, { nome: '', quantidade: 1, area: 0 }]);
  };

  const updateEsquadria = (idxComodo, idxEsq, field, value) => {
    setComodos(prev => prev.map((c, i) => {
      if (i !== idxComodo) return c;
      const esqs = [...(c.esquadrias || [])];
      esqs[idxEsq] = { ...esqs[idxEsq], [field]: value };
      return { ...c, esquadrias: esqs };
    }));
  };

  const addEsquadria = (idxComodo, tipo) => {
    setComodos(prev => prev.map((c, i) => {
      if (i !== idxComodo) return c;
      const nova = { tipo, quantidade: 1, material: tipo === 'Porta' ? 'Madeira' : 'Alumínio' };
      return { ...c, esquadrias: [...(c.esquadrias || []), nova] };
    }));
  };

  const removeEsquadria = (idxComodo, idxEsq) => {
    setComodos(prev => prev.map((c, i) => {
      if (i !== idxComodo) return c;
      return { ...c, esquadrias: (c.esquadrias || []).filter((_, j) => j !== idxEsq) };
    }));
  };

  const updateEspecial = (idxComodo, field, value) => {
    setComodos(prev => prev.map((c, i) => i === idxComodo ? {
      ...c, especiais: { ...(c.especiais || {}), [field]: value }
    } : c));
  };




  const formatArea = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '0.00';
    return num.toFixed(2);
  };

  // Grupos de cômodos que têm exceção natural
  // eslint-disable-next-line no-unused-vars
  const EXCECAO_SEM_JANELA   = ['banheiro', 'wc', 'lavabo', 'closet', 'despensa', 'depósito', 'deposito', 'hall', 'corredor', 'circulação', 'circulacao', 'lavanderia'];
  // eslint-disable-next-line no-unused-vars
  const EXCECAO_SEM_PORTA    = ['circulação', 'circulacao', 'corredor', 'hall', 'varanda', 'sacada'];





  const handleConfirm = () => {
    // Build pre-filled data for CUB page
    const cubCode = TIPO_PARA_CUB[tipoConstrucao]?.[padrao] || '';

    const prefilled = {
      estado,
      tipoProjeto: cubCode,
      areaConstruida: String(areaTotal),
      areaGaragem: areaGaragem || '',
      areaVaranda: areaVaranda || '',
      areaSubsolo: areaSubsolo || '',
      comodos,
      itensEspeciais,
      itensDetectados,
      observacoes,
      tipoConstrucao,
      padrao,
      nomeProjeto,
      peDireito,
      quantitativos_globais,
      cobertura,
      fromAnalysis: true,
    };

    localStorage.setItem('orcai_cub_prefill', JSON.stringify(prefilled));

    if (isCub) {
      navigate('/orcamento-cub?from=analise');
    } else {
      navigate('/orcamento-sinapi?from=analise');
    }
  };

  if (!analise) {
    return (
      <div className="min-h-screen flex flex-col bg-muted/30">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="w-10 h-10 border-4 border-primary/20 border-t-primary rounded-full animate-spin" />
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-muted/30">
      <Header />

      <main className="flex-1 px-4 pt-32 pb-16">
        <div className="max-w-5xl mx-auto">
          {/* Bruno header */}
          <div className="flex items-center gap-4 mb-6">
            <img src="/images/brand/bruno-principal.png" alt="Bruno" className="w-16 h-16 md:w-20 md:h-20 object-contain flex-shrink-0" />
            <div className="relative bg-card rounded-2xl shadow-card px-5 py-3 flex-1">
              <div className="absolute -left-2 top-1/2 -translate-y-1/2 w-4 h-4 bg-card rotate-45 shadow-card" />
              <p className="relative text-secondary font-medium text-sm leading-relaxed">
                Aqui está o que eu encontrei na sua planta! Confira os dados e ajuste o que precisar antes de calcular.
              </p>
            </div>
          </div>

          {/* Badge */}
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-xl font-bold text-secondary font-display">Confirmar Dados da Análise</h1>
            {isCub ? (
              <span className="text-xs font-semibold text-primary bg-primary/10 px-3 py-1 rounded-full">Estimativa CUB</span>
            ) : (
              <span className="text-xs font-semibold text-secondary bg-secondary/10 px-3 py-1 rounded-full">Orçamento SINAPI</span>
            )}
          </div>

          {/* Low confidence warning — só mostrar se maioria dos cômodos é baixa confiança */}
          {baixaConfianca && (
            comodos.every(c => !c.confianca) || comodos.filter(c => c.confianca === 'baixa').length > comodos.length / 2
          ) && (
            <div className="bg-amber-50 border-2 border-amber-400 rounded-2xl p-4 mb-6">
              <div className="flex items-start gap-3">
                <svg className="w-6 h-6 text-amber-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <div className="flex-1">
                  <p className="text-sm font-bold text-amber-800 mb-1">
                    Atenção: Análise com baixa confiança
                  </p>
                  <p className="text-sm text-amber-700">
                    {percentualDivergencia != null && percentualDivergencia > 0
                      ? `A IA detectou possíveis inconsistências nos cálculos de área. Divergência de ${percentualDivergencia}% entre a soma dos cômodos e a área total.`
                      : 'Algumas áreas foram estimadas visualmente por falta de cotas explícitas na planta.'}
                    {' '}Revise cuidadosamente os valores abaixo antes de prosseguir.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Alertas do Bruno */}
          {(() => {
            if (alertasBruno.length === 0) return (
              <div className="bg-green-50 border border-green-200 rounded-2xl p-4 mb-6 flex items-center gap-2">
                <span className="text-lg">✅</span>
                <p className="text-sm text-green-800 font-medium">Nenhum problema detectado na análise</p>
              </div>
            );
            const icone = { sem_porta: '⚠️', sem_janela: '⚠️', area_suspeita: '🔍', confianca_baixa: 'ℹ️' };
            const bg = { sem_porta: 'bg-yellow-50 border-yellow-200', sem_janela: 'bg-yellow-50 border-yellow-200', area_suspeita: 'bg-yellow-50 border-yellow-200', confianca_baixa: 'bg-blue-50 border-blue-200' };
            const visiveis = alertasBruno.slice(0, 5);
            const restantes = alertasBruno.length - 5;
            return (
              <div className="mb-6 space-y-2">
                <p className="text-sm font-semibold text-secondary mb-1">Alertas do Bruno:</p>
                {visiveis.map((a, i) => (
                  <div key={i} className={`flex items-center gap-2 rounded-xl border p-3 ${bg[a.tipo] || 'bg-yellow-50 border-yellow-200'}`}>
                    <span className="text-base shrink-0">{icone[a.tipo] || '⚠️'}</span>
                    <p className="text-sm text-foreground">{a.mensagem}</p>
                  </div>
                ))}
                {restantes > 0 && (
                  <p className="text-xs text-muted-foreground pl-2">e mais {restantes} alerta{restantes > 1 ? 's' : ''}...</p>
                )}
              </div>
            );
          })()}

          {/* Observations from Bruno — filtradas para linguagem de usuário */}
          {observacoes.length > 0 && (() => {
            const FILTROS = [
              /sanity check/i, /fator empirico/i, /fator de correcao/i,
              /perimetro externo/i, /aberturas internas/i, /baixa confianca/i,
              /metodo_calculo/i, /area_escrita/i, /CASO [123]/i,
            ];
            const UTIL = observacoes
              .filter(o => !FILTROS.some(r => r.test(o)))
              .slice(0, 4);
            if (!UTIL.length) return null;
            return (
              <div className="bg-primary/5 border border-primary/20 rounded-2xl p-4 mb-6">
                <p className="text-sm font-semibold text-primary mb-2">Observações do Bruno:</p>
                <ul className="space-y-1">
                  {UTIL.map((obs, i) => (
                    <li key={i} className="text-sm text-foreground flex gap-2">
                      <span className="text-primary flex-shrink-0">•</span> {obs}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })()}

          {/* Nome do Projeto */}
          <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
            <label className="block text-sm font-bold text-secondary mb-2 uppercase tracking-wide">Nome do Projeto (opcional)</label>
            <input
              type="text"
              value={nomeProjeto}
              onChange={(e) => setNomeProjeto(e.target.value)}
              placeholder="Ex: Casa da Praia, Reforma Apto 301..."
              className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>

          {/* General info card */}
          <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
            <h2 className="text-sm font-bold text-secondary mb-4 uppercase tracking-wide">Dados Gerais</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Área Total (m²)</label>
                <input
                  type="number"
                  value={areaTotal}
                  onChange={(e) => setAreaTotal(parseFloat(e.target.value) || 0)}
                  step="0.01"
                  className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm font-semibold text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                />
                <p className="text-xs text-muted-foreground mt-0.5">{formatArea(areaTotal)} m²</p>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Tipo de Construção</label>
                <select value={tipoConstrucao} onChange={(e) => setTipoConstrucao(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="">Selecione</option>
                  {TIPOS_CONSTRUCAO.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Padrão</label>
                <select value={padrao} onChange={(e) => setPadrao(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="">Selecione</option>
                  {PADROES_CONSTRUCAO.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Estado</label>
                <select value={estado} onChange={(e) => setEstado(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="">Selecione</option>
                  {estadosBrasil.map(est => <option key={est.sigla} value={est.sigla}>{est.nome}</option>)}
                </select>
              </div>
            </div>

            {/* Areas extras */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4 pt-4 border-t border-border">
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Garagem (m²)</label>
                <input type="number" value={areaGaragem} onChange={(e) => setAreaGaragem(e.target.value)} step="0.01" placeholder="0" className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent" />
                {areaGaragem && <p className="text-xs text-muted-foreground mt-0.5">{formatArea(areaGaragem)} m²</p>}
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Varanda / Sacada (m²)</label>
                <input type="number" value={areaVaranda} onChange={(e) => setAreaVaranda(e.target.value)} step="0.01" placeholder="0" className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent" />
                {areaVaranda && <p className="text-xs text-muted-foreground mt-0.5">{formatArea(areaVaranda)} m²</p>}
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Subsolo (m²)</label>
                <input type="number" value={areaSubsolo} onChange={(e) => setAreaSubsolo(e.target.value)} step="0.01" placeholder="0" className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent" />
                {areaSubsolo && <p className="text-xs text-muted-foreground mt-0.5">{formatArea(areaSubsolo)} m²</p>}
              </div>
            </div>
          </div>

          {/* Rooms card */}
          <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-sm font-bold text-secondary uppercase tracking-wide">Cômodos Identificados</h2>
              <button onClick={recalcArea} className="text-xs text-primary font-semibold hover:underline">
                Recalcular área total
              </button>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <button onClick={() => setViewMode('tabela')}
                className={viewMode === 'tabela' ? 'bg-orange-500 text-white font-medium px-4 py-2 rounded-lg shadow-sm' : 'bg-gray-100 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-200'}>
                Ver em Tabela
              </button>
              <button onClick={() => setViewMode('planta')}
                className={viewMode === 'planta' ? 'bg-orange-500 text-white font-medium px-4 py-2 rounded-lg shadow-sm' : 'bg-gray-100 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-200'}
                disabled={!engineData?.overlay_disponivel}>
                Ver na Planta
              </button>
              <button onClick={() => navigate(`/qco-plan?tipo=${tipoFluxo}`)}
                className="bg-orange-500 text-white font-medium px-4 py-2 rounded-lg shadow-sm hover:bg-orange-600"
                disabled={!engineData?.overlay_disponivel}>
                ✨ QCO Plan
              </button>
              {viewMode === 'planta' && (
                <div className="flex items-center gap-2 ml-4">
                  <span className="text-xs text-gray-500">Colorir por:</span>
                  <button onClick={() => setModoVisualizacao('familia')}
                    className={modoVisualizacao === 'familia' ? 'bg-[#1E3A5F] text-white text-xs px-3 py-1 rounded-full' : 'bg-gray-100 text-gray-500 text-xs px-3 py-1 rounded-full'}>
                    Tipo
                  </button>
                  <button onClick={() => setModoVisualizacao('custo')}
                    className={modoVisualizacao === 'custo' ? 'bg-[#1E3A5F] text-white text-xs px-3 py-1 rounded-full' : 'bg-gray-100 text-gray-500 text-xs px-3 py-1 rounded-full'}>
                    Custo
                  </button>
                </div>
              )}
            </div>

            {viewMode === 'planta' ? (
              <div>
                <div className="bg-blue-50 text-blue-700 text-xs p-3 rounded-lg mb-4">
                  As posições dos cômodos são aproximadas e servem como referência visual.
                </div>
                <PlantaOverlay
                  imagemPlanta={engineData?.imagem_planta}
                  comodos={comodos}
                  modoVisualizacao={modoVisualizacao}
                  onComodoClick={() => {}}
                  onAcabamentoChange={(idx, campo, valor) => updateAcabamento(idx, campo, valor)}
                  onEspecialChange={(idx, campo, valor) => updateEspecial(idx, campo, valor)}
                  onEsquadriaChange={(idxC, idxE, campo, valor) => updateEsquadria(idxC, idxE, campo, valor)}
                  onAddEsquadria={(idxC, tipo) => addEsquadria(idxC, tipo)}
                  onRemoveEsquadria={(idxC, idxE) => removeEsquadria(idxC, idxE)}
                  onBboxUpdate={(idx, newBbox) => {
                    setComodos(prev => prev.map((c, i) => i === idx ? { ...c, bbox: newBbox } : c));
                  }}
                  onComodoFieldChange={(idx, campo, valor) => {
                    setComodos(prev => prev.map((c, i) => i === idx ? { ...c, [campo]: valor } : c));
                  }}
                  opcoesAcabamento={{
                    piso: OPCOES_PISO,
                    forro: OPCOES_FORRO,
                    revParede: OPCOES_REV_PAREDE,
                    alturaRev: OPCOES_ALTURA_REV,
                    rodape: OPCOES_RODAPE,
                    reboco: OPCOES_REBOCO,
                    bancada: OPCOES_BANCADA,
                    pia: OPCOES_PIA,
                    soleira: OPCOES_SOLEIRA,
                    matEsquadria: OPCOES_MAT_ESQUADRIA,
                  }}
                />
              </div>
            ) : comodos.length > 0 ? (
              <div>
                <div className="space-y-2">
                  {(() => {
                    const pavimentos = [...new Set(comodos.map(c => c.pavimento).filter(Boolean))];
                    const multiPav = pavimentos.length > 1;
                    const limparPav = (p) => (p || '').replace(/^-\s*/, '').trim();
                    // Ordenar por pavimento (só visual — não altera array original)
                    const comodosOrdenados = multiPav
                      ? [...comodos].map((c, origIdx) => ({ ...c, _origIdx: origIdx })).sort((a, b) => {
                          const pA = limparPav(a.pavimento).toLowerCase();
                          const pB = limparPav(b.pavimento).toLowerCase();
                          const isTerA = /t[eé]rr/i.test(pA);
                          const isTerB = /t[eé]rr/i.test(pB);
                          if (isTerA && !isTerB) return -1;
                          if (!isTerA && isTerB) return 1;
                          if (!a.pavimento && b.pavimento) return 1;
                          if (a.pavimento && !b.pavimento) return -1;
                          return pA.localeCompare(pB);
                        })
                      : comodos.map((c, origIdx) => ({ ...c, _origIdx: origIdx }));
                    let lastPav = null;
                    return comodosOrdenados.map((c) => {
                      const i = c._origIdx;
                      const pavLimpo = limparPav(c.pavimento);
                      const showHeader = multiPav && c.pavimento && pavLimpo !== lastPav;
                      if (showHeader) lastPav = pavLimpo;
                      return (
                        <div key={i}>
                          {showHeader && (
                            <div className="text-lg font-semibold text-[#1E3A5F] border-b mb-2 mt-4 pb-1">
                              {pavLimpo}
                            </div>
                          )}
                          {(() => {
                    const acab = c.acabamento || {};
                    const precisaAltura = REV_PRECISA_ALTURA.includes(acab.tipoRevParede);
                    const ceramicaPisoAoTeto = precisaAltura && (acab.alturaRevestimento || '').includes('teto');
                    const isOpen = acordeonAberto === i;
                    const esqs = c.esquadrias || [];
                    const esp = c.especiais || {};
                    const isProjecao = c.tipo_escada === 'projecao';

                    return (
                      <div key={i} className={`rounded-xl border transition-all ${isProjecao ? 'border-gray-200 bg-gray-50 opacity-60' : isOpen ? 'border-primary/40 bg-primary/5' : 'border-border bg-muted/30'}`} title={isProjecao ? 'Esta escada conecta os dois pavimentos. A área já foi contabilizada no andar de origem.' : undefined}>
                        {/* Linha resumo — clicável */}
                        <div
                          className="flex items-center gap-2 px-3 py-2.5 cursor-pointer select-none"
                          onClick={() => setAcordeonAberto(isOpen ? null : i)}
                        >
                          <div className="flex-1 min-w-0 flex items-center gap-1">
                            <input
                              value={c.nome}
                              onChange={e => { e.stopPropagation(); updateComodo(i, 'nome', e.target.value); }}
                              onClick={e => e.stopPropagation()}
                              placeholder="Nome do cômodo"
                              className="flex-1 bg-transparent text-sm font-semibold text-foreground outline-none border-b border-transparent focus:border-primary/50 hover:border-primary/30 truncate"
                            />
                            {!isProjecao && (
                              <svg className="w-3 h-3 text-muted-foreground/50 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" title="Clique para editar o nome">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                              </svg>
                            )}
                            {isProjecao && (
                              <span className="text-xs text-gray-400 italic shrink-0">(projeção)</span>
                            )}
                            {multiPav && c.pavimento && (
                              <span className="text-sm text-gray-500 shrink-0 hidden sm:inline">— {limparPav(c.pavimento)}</span>
                            )}
                            {!isProjecao && (() => {
                              const cfg = {
                                alta:  { bg: 'bg-green-100 text-green-800 border-green-300',  icon: '✓', tip: 'Leitura confirmada por múltiplas verificações' },
                                media: { bg: 'bg-yellow-100 text-yellow-800 border-yellow-300', icon: '~', tip: 'Leitura parcialmente verificada — confira o valor' },
                                baixa: { bg: 'bg-red-100 text-red-800 border-red-300',      icon: '!', tip: 'Estimativa aproximada — recomendamos conferir na planta' },
                              }[c.confianca || 'media'];
                              return cfg ? (
                                <span className={`text-xs w-5 h-5 flex items-center justify-center rounded-full border font-bold shrink-0 ${cfg.bg}`} title={cfg.tip}>
                                  {cfg.icon}
                                </span>
                              ) : null;
                            })()}
                          </div>
                          <span className="text-xs text-muted-foreground whitespace-nowrap shrink-0">
                            <input
                              type="number"
                              value={c.area}
                              onChange={e => { e.stopPropagation(); updateComodo(i, 'area', parseFloat(e.target.value) || 0); }}
                              onClick={e => e.stopPropagation()}
                              step="0.01"
                              className="w-14 text-center bg-transparent text-xs text-muted-foreground outline-none border-b border-transparent focus:border-primary/50"
                            /> m²
                          </span>
                          <span className="text-xs text-muted-foreground shrink-0 hidden sm:block truncate max-w-[80px]">{acab.tipoPiso || '—'}</span>
                          <span className="text-xs text-muted-foreground shrink-0 hidden md:block truncate max-w-[70px]">{acab.forro || '—'}</span>
                          <span className="text-xs text-muted-foreground shrink-0 hidden lg:block truncate max-w-[90px]">{acab.tipoRevParede || '—'}</span>
                          <button
                            onClick={e => { e.stopPropagation(); removeComodo(i); }}
                            className="text-destructive/50 hover:text-destructive shrink-0 p-1"
                            title="Remover"
                          >
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                          <svg className={`w-4 h-4 text-muted-foreground shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>

                        {/* Painel expandido */}
                        {isOpen && (
                          <div className="px-3 pb-4 border-t border-border/40 pt-3">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                              {/* Coluna 1 — Acabamentos */}
                              <div>
                                <p className="text-xs font-bold text-muted-foreground uppercase tracking-wide mb-2">Acabamentos</p>
                                <div className="space-y-2">
                                  <div>
                                    <label className="text-xs text-muted-foreground">Piso</label>
                                    <select value={acab.tipoPiso || ''} onChange={e => updateAcabamento(i, 'tipoPiso', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">—</option>
                                      {OPCOES_PISO.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Rodapé</label>
                                    <select value={acab.tipoRodape || 'Sem rodapé'} onChange={e => updateAcabamento(i, 'tipoRodape', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      {OPCOES_RODAPE.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Forro</label>
                                    <select value={acab.forro || ''} onChange={e => updateAcabamento(i, 'forro', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">—</option>
                                      {OPCOES_FORRO.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Rev. Parede</label>
                                    <select value={acab.tipoRevParede || 'Sem revestimento'} onChange={e => updateAcabamento(i, 'tipoRevParede', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      {OPCOES_REV_PAREDE.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Altura Rev.</label>
                                    <select value={acab.alturaRevestimento || ''} onChange={e => updateAcabamento(i, 'alturaRevestimento', e.target.value)}
                                      disabled={!precisaAltura}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground disabled:opacity-40 disabled:cursor-not-allowed">
                                      <option value="">—</option>
                                      {OPCOES_ALTURA_REV.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Reboco</label>
                                    {ceramicaPisoAoTeto ? (
                                      <p className="mt-0.5 px-2 py-1.5 text-xs text-muted-foreground italic">Não se aplica (cerâmica piso ao teto)</p>
                                    ) : (
                                      <select value={acab.tipoReboco || 'Massa corrida PVA'} onChange={e => updateAcabamento(i, 'tipoReboco', e.target.value)}
                                        className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                        {OPCOES_REBOCO.map(op => <option key={op} value={op}>{op}</option>)}
                                      </select>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Coluna 2 — Esquadrias */}
                              <div>
                                <p className="text-xs font-bold text-muted-foreground uppercase tracking-wide mb-2">Esquadrias</p>
                                <div className="space-y-2">
                                  {esqs.length === 0 && (
                                    <p className="text-xs text-muted-foreground italic">Nenhuma esquadria detectada</p>
                                  )}
                                  {esqs.map((esq, j) => (
                                    <div key={j} className="space-y-1 pb-2 border-b border-border/30 last:border-0">
                                      <div className="flex items-center gap-1.5">
                                        <select value={esq.tipo || 'Porta'} onChange={e => updateEsquadria(i, j, 'tipo', e.target.value)}
                                          className="flex-1 px-1.5 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                          <option>Porta</option>
                                          <option>Porta de correr</option>
                                          <option>Porta de enrolar</option>
                                          <option>Janela</option>
                                          <option>Janela de correr</option>
                                          <option>Basculante</option>
                                          <option>Vidro fixo</option>
                                        </select>
                                        <input type="number" min="1" value={esq.quantidade || 1} onChange={e => updateEsquadria(i, j, 'quantidade', parseInt(e.target.value) || 1)}
                                          className="w-9 text-center px-1 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground" title="Qtd" />
                                        <button onClick={() => removeEsquadria(i, j)} className="text-destructive/50 hover:text-destructive shrink-0">
                                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="flex items-center gap-1.5">
                                        <select value={esq.material || ''} onChange={e => updateEsquadria(i, j, 'material', e.target.value)}
                                          className="flex-1 px-1.5 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                          <option value="">Material —</option>
                                          {OPCOES_MAT_ESQUADRIA.map(op => <option key={op} value={op}>{op}</option>)}
                                        </select>
                                        <input
                                          value={esq.dimensoes || ''}
                                          onChange={e => updateEsquadria(i, j, 'dimensoes', e.target.value)}
                                          placeholder="0.90x2.10"
                                          className="w-24 px-1.5 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground font-mono"
                                          title="Dimensões LxA (metros)"
                                        />
                                      </div>
                                    </div>
                                  ))}
                                  <div className="flex gap-2 mt-1">
                                    <button onClick={() => addEsquadria(i, 'Porta')}
                                      className="text-xs text-primary hover:underline">+ Porta</button>
                                    <button onClick={() => addEsquadria(i, 'Janela')}
                                      className="text-xs text-primary hover:underline">+ Janela</button>
                                  </div>
                                </div>
                              </div>

                              {/* Coluna 3 — Bancadas e Especiais */}
                              <div>
                                <p className="text-xs font-bold text-muted-foreground uppercase tracking-wide mb-2">Bancadas / Especiais</p>
                                <div className="space-y-2">
                                  <div>
                                    <label className="text-xs text-muted-foreground">Bancada</label>
                                    <select value={esp.bancada || ''} onChange={e => updateEspecial(i, 'bancada', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">Sem bancada</option>
                                      {OPCOES_BANCADA.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Pia / Cuba / Tanque</label>
                                    <select value={esp.pia || ''} onChange={e => updateEspecial(i, 'pia', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">Sem pia/tanque</option>
                                      {OPCOES_PIA.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Soleira</label>
                                    <select value={esp.soleira || ''} onChange={e => updateEspecial(i, 'soleira', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">Sem soleira</option>
                                      {OPCOES_SOLEIRA.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                  <div>
                                    <label className="text-xs text-muted-foreground">Peitoril</label>
                                    <select value={esp.peitoril || ''} onChange={e => updateEspecial(i, 'peitoril', e.target.value)}
                                      className="w-full mt-0.5 px-2 py-1.5 rounded-lg border border-border bg-background text-xs text-foreground">
                                      <option value="">Sem peitoril</option>
                                      {OPCOES_SOLEIRA.map(op => <option key={op} value={op}>{op}</option>)}
                                    </select>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground text-center py-4">Nenhum cômodo identificado. Adicione manualmente.</p>
            )}
            <button onClick={addComodo} className="mt-4 text-sm text-primary font-semibold hover:underline flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
              Adicionar cômodo
            </button>

            {/* Pé direito — logo abaixo dos cômodos */}
            <div className="mt-4 pt-4 border-t border-border/50">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="text-sm font-medium text-foreground whitespace-nowrap">Pé direito:</span>
                {OPCOES_PE_DIREITO.map(opcao => (
                  <button key={opcao} type="button" onClick={() => { setPeDireito(opcao); setPeDireitoCustom(''); }}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium border-2 transition-all ${
                      peDireito === opcao && !peDireitoCustom ? 'border-primary bg-primary/10 text-primary' : 'border-border text-muted-foreground hover:border-primary/40'
                    }`}>{opcao}</button>
                ))}
                <div className={`flex items-center gap-1.5 rounded-lg border-2 px-2 py-1 transition-all ${
                  peDireitoCustom ? 'border-primary bg-primary/10' : 'border-border'
                }`}>
                  <input
                    type="number"
                    min="2.20"
                    max="6.00"
                    step="0.05"
                    placeholder="Outro"
                    value={peDireitoCustom}
                    onChange={e => {
                      setPeDireitoCustom(e.target.value);
                      if (e.target.value) setPeDireito(e.target.value.replace('.', ',') + 'm');
                    }}
                    className={`w-16 bg-transparent text-sm font-medium outline-none ${peDireitoCustom ? 'text-primary' : 'text-muted-foreground'}`}
                  />
                  <span className={`text-sm font-medium ${peDireitoCustom ? 'text-primary' : 'text-muted-foreground'}`}>m</span>
                </div>
              </div>
            </div>
          </div>

          {/* Cobertura */}
          <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
            <h2 className="text-sm font-bold text-secondary uppercase tracking-wide mb-4">Cobertura</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Tipo de telha *</label>
                <select value={cobertura.tipo} onChange={e => {
                  const novoTipo = e.target.value;
                  const inclinacaoSugerida = INCLINACAO_POR_TELHA[novoTipo] || cobertura.inclinacao;
                  setCobertura(prev => ({ ...prev, tipo: novoTipo, inclinacao: inclinacaoSugerida }));
                }}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="">Selecione</option>
                  <option value="Cerâmica colonial">Cerâmica colonial</option>
                  <option value="Cerâmica romana">Cerâmica romana</option>
                  <option value="Cerâmica portuguesa">Cerâmica portuguesa</option>
                  <option value="Concreto">Concreto</option>
                  <option value="Fibrocimento">Fibrocimento</option>
                  <option value="Metálica/galvanizada">Metálica/galvanizada</option>
                  <option value="Sanduíche termoacústica">Sanduíche termoacústica</option>
                  <option value="Laje impermeabilizada">Laje impermeabilizada</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Área de cobertura (m²)</label>
                <input type="number" min="0" step="0.01" value={cobertura.areaM2}
                  onChange={e => setCobertura(prev => ({ ...prev, areaM2: e.target.value }))}
                  placeholder="Ex: 85"
                  className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent" />
                <p className="text-xs text-muted-foreground mt-0.5">Projeção horizontal do telhado</p>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Estrutura</label>
                <select value={cobertura.estrutura} onChange={e => setCobertura(prev => ({ ...prev, estrutura: e.target.value }))}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="madeira">Madeiramento (tesoura)</option>
                  <option value="metalica">Estrutura metálica</option>
                  <option value="laje">Laje (sem estrutura)</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-muted-foreground mb-1">Inclinação (%)</label>
                <select value={cobertura.inclinacao} onChange={e => setCobertura(prev => ({ ...prev, inclinacao: e.target.value }))}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option value="15">15% — telha metálica/fibrocimento</option>
                  <option value="30">30% — telha cerâmica/concreto (padrão)</option>
                  <option value="40">40% — telhado íngreme</option>
                  <option value="0">0% — laje plana</option>
                </select>
              </div>
            </div>
          </div>
          {itensExternos && itensExternos.length > 0 && (
            <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
              <button
                type="button"
                onClick={() => setExternasAberta(prev => !prev)}
                className="w-full flex items-center justify-between"
              >
                <h2 className="text-sm font-bold text-secondary uppercase tracking-wide">Áreas Externas Identificadas</h2>
                <svg
                  className={`w-5 h-5 text-muted-foreground transition-transform ${externasAberta ? 'rotate-180' : ''}`}
                  fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {externasAberta && (
                <div className="mt-3 space-y-2">
                  {itensExternos.map((item, i) => (
                    <div key={i} className="flex items-center justify-between bg-muted/50 rounded-lg px-3 py-2">
                      <span className="text-sm text-foreground">{item.nome || '—'}</span>
                      <span className="text-sm font-semibold text-primary">
                        {item.area != null ? `${parseFloat(item.area).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m²` : '—'}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Detected items */}
          {(() => {
            const itensValidos = (itensDetectados || []).filter(item => 
              item.item && 
              item.item.trim() !== '' && 
              item.item.trim() !== '—' &&
              item.item.trim() !== '-' &&
              !item.item.trim().startsWith('0x') &&
              (parseInt(item.quantidade) || 0) > 0
            );
            return (
              <div className="bg-card rounded-2xl shadow-card p-6 mb-4">
                <h2 className="text-sm font-bold text-secondary mb-3 uppercase tracking-wide">Itens Detectados na Planta</h2>
                {itensValidos.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {itensValidos.map((item, i) => (
                      <div key={i} className="flex items-center gap-2 bg-muted/50 rounded-lg px-3 py-2">
                        <span className="text-primary text-xs font-bold">{item.quantidade}x</span>
                        <span className="text-sm text-foreground">{item.item}</span>
                        <span className="text-xs text-muted-foreground ml-auto">{item.comodo || ''}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-muted-foreground text-center py-4">Nenhum item especial identificado nesta planta.</p>
                )}
              </div>
            );
          })()}



                    <div className="flex gap-3">
            <button
              onClick={() => navigate(-1)}
              className="flex-1 py-3.5 font-semibold rounded-xl border-2 border-border text-foreground hover:bg-muted transition-colors"
            >
              Voltar
            </button>
            <button
              onClick={handleConfirm}
              disabled={!tipoConstrucao || !padrao || !estado || areaTotal <= 0}
              className={`flex-[2] py-3.5 font-bold rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-white disabled:opacity-50 ${
                isCub ? 'bg-primary hover:bg-primary/90' : 'bg-secondary hover:bg-secondary/90'
              }`}
            >
              Confirmar e Calcular
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </main>

      <Footer />




    </div>
  );
}
